import { render, staticRenderFns } from "./NewAccountDetail.vue?vue&type=template&id=5e382b24&scoped=true"
import script from "./NewAccountDetail.vue?vue&type=script&lang=js"
export * from "./NewAccountDetail.vue?vue&type=script&lang=js"
import style0 from "./NewAccountDetail.vue?vue&type=style&index=0&id=5e382b24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e382b24",
  null
  
)

export default component.exports